import { render, staticRenderFns } from "./dailyRosterTv.vue?vue&type=template&id=4fe485a9&scoped=true"
import script from "./dailyRosterTv.vue?vue&type=script&lang=js"
export * from "./dailyRosterTv.vue?vue&type=script&lang=js"
import style0 from "./dailyRosterTv.vue?vue&type=style&index=0&id=4fe485a9&prod&lang=css"
import style1 from "./dailyRosterTv.vue?vue&type=style&index=1&id=4fe485a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe485a9",
  null
  
)

export default component.exports